import React, { memo } from 'react';

import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

import { Card } from './components';
import * as S from './styles';

function Islands({ data, idposto, modalRef }) {
  return (
    <S.Wrapper>
      <header>
        <Typography>{data.nomeIlha}</Typography>
      </header>
      {/* TCD */}
      {data.listaPresetDados &&
        data.listaPresetDados.map((item) => (
          <Card
            key={Math.random().toString()}
            data={item}
            idposto={idposto}
            modalRef={modalRef}
          />
        ))}
    </S.Wrapper>
  );
}

Islands.propTypes = {
  data: PropTypes.objectOf({
    idIlha: PropTypes.number.isRequired,
    nomeIlha: PropTypes.string.isRequired,
    listaPresetDados: PropTypes.arrayOf(PropTypes.any),
  }).isRequired,
  idposto: PropTypes.number.isRequired,
  modalRef: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default memo(Islands);
